import { useEffect } from "react";

export const usePageMeta = ({ title, description }) => {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) {
        tag = document.createElement("meta");
        tag.name = "description";
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", description);
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [title, description]);
};
